<script>
export default {
    name: "UiImage",
    props: {
        path: { type: String, required: true },
        alt: { type: String, default: "" },
        lazy: { type: Boolean, default: true },
        mobile: { type: Object, default: () => ({ width: 414, height: 0 }) },
        desktop: { type: Object, default: () => ({ width: 1440, height: 0 }) },
    },
    computed: {
        sources() {
            const mobile = this.$img.resize(this.$props.path, this.$props.mobile.width, this.$props.mobile.height);
            const desktop = this.$img.resize(this.$props.path, this.$props.desktop.width, this.$props.desktop.height);
            return {
                mobile: {
                    jpg: {
                        src: mobile.srcJpg,
                        srcset: mobile.srcsetJpg,
                    },
                    webp: {
                        src: mobile.srcWebp,
                        srcset: mobile.srcsetWebp,
                    },
                },
                desktop: {
                    jpg: {
                        src: desktop.srcJpg,
                        srcset: desktop.srcsetJpg,
                    },
                    webp: {
                        src: desktop.srcWebp,
                        srcset: desktop.srcsetWebp,
                    },
                },
            };
        },
        aspectRatioDesktop() {
            if (this.desktop.width && this.desktop.height) {
                return `${this.desktop.width} / ${this.desktop.height}`;
            }
            return "auto";
        },
        aspectRatioMobile() {
            if (this.mobile.width && this.mobile.height) {
                return `${this.mobile.width} / ${this.mobile.height}`;
            }
            return "auto";
        },
    },
};
</script>

<template>
    <picture
        :data-not-lazy="!lazy || null"
        :style="{
            '--aspect-desktop': aspectRatioDesktop,
            '--aspect-mobile': aspectRatioMobile,
        }">
        <!-- mobile -->
        <source
            :loading="lazy ? 'lazy' : null"
            v-lazy-load :data-srcset="`${sources.mobile.webp.src}, ${sources.mobile.webp.srcset}`"
            :data-not-lazy="!lazy || null"
            type="image/webp"
            media="(max-width: 750px)" />
        <source
            :loading="lazy ? 'lazy' : null"
            v-lazy-load :data-srcset="`${sources.mobile.jpg.src}, ${sources.mobile.jpg.srcset}`"
            :data-not-lazy="!lazy || null"
            type="image/jpeg"
            media="(max-width: 750px)" />
        <!-- desktop (default) -->
        <source
            :loading="lazy ? 'lazy' : null"
            v-lazy-load :data-srcset="`${sources.desktop.webp.src}, ${sources.desktop.webp.srcset}`"
            :data-not-lazy="!lazy || null"
            type="image/webp" />
        <source
            :loading="lazy ? 'lazy' : null"
            v-lazy-load :data-srcset="`${sources.desktop.jpg.src}, ${sources.desktop.jpg.srcset}`"
            :data-not-lazy="!lazy || null"
            type="image/jpeg" />

        <!-- fallback <img> -->
        <img
            v-lazy-load :data-src="sources.desktop.webp.src"
            v-lazy-load :data-srcset="sources.desktop.webp.srcset"
            :alt="alt"
            :data-not-lazy="!lazy || null"
            :loading="lazy ? 'lazy' : null" />
    </picture>
</template>

<style scoped lang="less">
img {
    width: 100%;
    height: 100%;
    aspect-ratio: var(--aspect-desktop);
    object-fit: cover;
    @media @sm {
        aspect-ratio: var(--aspect-mobile);
    }
}
@media @sm {
    picture.instant-load.lazyLoad,
    picture.instant-load img {
        animation: none !important;
        opacity: 1 !important;
    }
}
@media @notsm {
    picture.lazyLoad,
    picture img {
        animation: none !important;
        opacity: 1 !important;
    }
}
</style>
